import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { DecimalPipe } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { Subdomain } from '../../../interfaces/asm/models';
import * as XLSX from 'xlsx';

@Component({
    selector: 'app-subdomains',
    standalone: true,
    imports: [
        MatCardModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatButtonModule,
        TranslocoModule,
        DecimalPipe,
    ],
    templateUrl: './subdomains.component.html',
    styleUrl: './subdomains.component.scss',
})
export class SubdomainsComponent {
    displayedColumns: string[] = [
        'subdomain',
        'status',
        'title',
        'ip',
        'contentLength',
        'responseTime',
    ];

    @Input() data: Subdomain[] = [];
    dataSource = new MatTableDataSource<Subdomain>(this.data);
    pageSizes = [10, 20, 50, 1000];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('TABLE') table: ElementRef;

    // isToggled
    isToggled = false;

    constructor(
        public themeService: CustomizerSettingsService,
    ) {
        this.themeService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

    }

    /**
     * After View Init
     */
    ngAfterViewInit(): void {

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    // changeData
    changeData() {
        this.dataSource.data = this.data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

    // RTL Mode
    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

    // Search Filter
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    // onKeydown
    onKeydown(event: Event) {
        //console.log(event);
        return false;
    }

    // exportTOExcel
    exportTOExcel() {
        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
            this.table.nativeElement
        );
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'subdomains');

        /* save to file */
        XLSX.writeFile(wb, 'export.xlsx');
    }
}
